import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { Scrollable } from '../../../shared/scrollable/Scrollable';
import { Toggle } from '../../../shared/toggle';
import { InformationTooltip } from '../../../shared/tooltip';
import styles from '../Clients.module.scss';
import { Client, ClientOpinion, getAvailableClientFeaturePermissions, updateClientDetails } from '../store';

const { white, lightestGrey } = styles;

interface ClientFeaturePermissionsProps {
    clientFeaturePermissionIds: number[] | null;
}

export const ClientFeaturePermissions: React.FC<ClientFeaturePermissionsProps> = ({ clientFeaturePermissionIds }) => {
    const dispatch = useAppDispatch();

    const updateClientProperties = useCallback((key: keyof Client, value: string | number[] | ClientOpinion[] | number | null) => dispatch(updateClientDetails(key, value)), [dispatch]);
    const allClientFeaturePermissions = useAppSelector(getAvailableClientFeaturePermissions);

    const permissionOptions = useMemo(() => allClientFeaturePermissions.filter(({ label }) => label).sort((a, b) => a.label.localeCompare(b.label)), [allClientFeaturePermissions]);

    const updateClientFeaturePermissionIds = (checked: boolean, featurePermissionId: number) => {
        const featurePermissions = checked ? [...clientFeaturePermissionIds!, featurePermissionId] : clientFeaturePermissionIds!.filter(id => id !== featurePermissionId);
        updateClientProperties('clientFeaturePermissionIds', featurePermissions);
    };

    const permissionOptionHeaders = [{ name: 'Permission' }, { name: 'Has Permission' }];

    return (
        <div className={styles.clientModalContentWrapper}>
            <div className={styles.clientModalHeader}>
                <div className={styles.clientModalTitle}>Feature Permissions Available to Client</div>
            </div>
            <>
                <div className={styles.tableHeader}>
                    {permissionOptionHeaders.map(({ name }) => (
                        <div key={name}>{name}</div>
                    ))}
                </div>
                <div className={styles.tableWrapper}>
                    <Scrollable>
                        {permissionOptions.map(({ clientFeaturePermissionId, label, description }, index) => (
                            <div className={styles.tableRow} key={index} style={{ backgroundColor: index % 2 ? lightestGrey : white }}>
                                <div className={styles.featurePermissionInfo}>
                                    <div className={styles.featurePermissionLabel}>{label}</div>
                                    <div className={styles.featurePermissionDescription}><InformationTooltip content={description} /></div>
                                </div>
                                <Toggle
                                    checked={clientFeaturePermissionIds ? clientFeaturePermissionIds.includes(clientFeaturePermissionId!) : false}
                                    onChange={checked => updateClientFeaturePermissionIds(checked, clientFeaturePermissionId!)}
                                />
                            </div>
                        ))}
                    </Scrollable>
                </div>
            </>
        </div>
    );
};
